import React, { useEffect, useRef } from "react";
import { Camera } from "lucide-react";

// B1/T4-3: признак «фотоотчёт = доказательство» — фото/видео/аудио отчёта видны заказчику в полном качестве до подтверждения.
// Матрица дефолтов по подкатегории general: доказательные — ВКЛ, продуктовые (результат — сам файл) — ВЫКЛ.
export const EVIDENCE_SUBCATEGORIES = ["property_check", "errand", "courier", "household", "cleaning", "moving", "pet_sitting"];
const PRODUCT_CONFIRM_TEXT = "Исполнитель потеряет водяной знак до подтверждения: включайте, только если фото доказывают работу, а не являются её результатом.";

export const EvidenceReportToggle = ({ formData, setFormData }) => {
  const touched = useRef(false);
  const visible = formData.service_type === "general" && !formData.is_b2b;
  const evidenceSub = EVIDENCE_SUBCATEGORIES.includes(formData.task_subcategory);

  // Смена чипа подкатегории = новый дефолт по матрице (ручной выбор действует до следующей смены чипа)
  useEffect(() => {
    touched.current = false;
    if (!visible) return;
    setFormData((prev) => (prev.evidence_photo_report === evidenceSub ? prev : { ...prev, evidence_photo_report: evidenceSub }));
  }, [formData.task_subcategory, visible]);

  const onToggle = (e) => {
    const checked = e.target.checked;
    if (checked && !evidenceSub && !window.confirm(PRODUCT_CONFIRM_TEXT)) return;
    touched.current = true;
    setFormData((prev) => ({ ...prev, evidence_photo_report: checked }));
  };

  if (!visible) return null;
  return (
    <label className="flex items-start gap-2 rounded-lg p-3 cursor-pointer" style={{ background: "#F8FAFC", border: "1px solid var(--rv-border)" }} data-testid="evidence-report-toggle">
      <input type="checkbox" className="mt-0.5" checked={!!formData.evidence_photo_report} data-testid="evidence-report-checkbox" onChange={onToggle} />
      <span className="text-sm">
        <span className="font-medium flex items-center gap-1.5"><Camera size={15} /> Фотоотчёт — доказательство выполнения</span>
        <span className="block text-xs mt-0.5" style={{ color: "var(--rv-text-secondary)" }}>
          Фото, видео и аудио отчёта будут видны вам в полном качестве сразу, без водяного знака, чтобы вы принимали работу не вслепую.
          Подходит для уборки, доставки, выгула, монтажа и проверок. Если результат — сам файл (фотосъёмка, дизайн), оставьте выключенным:
          полное качество откроется после подтверждения задания.
          {evidenceSub && <span className="block mt-1" style={{ color: "var(--rv-teal)" }} data-testid="evidence-report-suggested">Для этого типа задания включено по умолчанию.</span>}
        </span>
      </span>
    </label>
  );
};
